import { BaseQtInteropAPI, createQtCall, createVoidQtCall } from '@tableau/qt-hybrid-interop';
import { QWebChannel } from 'qwebchannel';
import { DesktopTelemetryClient } from './DesktopTemetryClient';
import { AddInApiPresLayerInteropObject } from './types/AddInApiPresLayerInteropObject';
import './types/QtTypes';

function createPresLayerObject(baseQtAPI: BaseQtInteropAPI): AddInApiPresLayerInteropObject {
  const apiCopy = Object.create(baseQtAPI);
  apiCopy.ExecuteCommand = createQtCall(baseQtAPI, 'ExecuteCommand');
  apiCopy.RegisterNotificationHandler = createVoidQtCall(baseQtAPI, 'RegisterNotificationHandler');
  return apiCopy;
}

function createTelemetryObject(baseQtAPI: BaseQtInteropAPI): void {
  const apiCopy = Object.create(baseQtAPI);
  apiCopy.ForwardTelemetry = createVoidQtCall(baseQtAPI, 'ForwardTelemetry');
  DesktopTelemetryClient.setInstance(apiCopy);
}

/**
 * Initializes the QWebChannel contract and returns the pres layer interop object
 *
 * @returns {Promise<AddInApiPresLayerInteropObject>}
 */
export function initializeWebChannelPresLayer(): Promise<AddInApiPresLayerInteropObject> {
  return new Promise<AddInApiPresLayerInteropObject>((resolve, reject) => {
    try {
      // tslint:disable-next-line
      new QWebChannel(qt.webChannelTransport, (channel) => {
        // tslint:disable-next-line
        const testhook = channel.objects['extensionsApiTestObj'];
        if (testhook) {
          // tslint:disable-next-line
          (window as any).tableau_testhook = testhook;
        }

        // tslint:disable-next-line
        const baseTelemetryAPI = channel.objects['telemetry'] as BaseQtInteropAPI;
        createTelemetryObject(baseTelemetryAPI);

        // tslint:disable-next-line
        const basePresLayerAPI = channel.objects['addInPresLayer'] as BaseQtInteropAPI;
        const addInPresLayer = createPresLayerObject(basePresLayerAPI);
        resolve(addInPresLayer);
      });
    } catch (e) {
      reject(e);
    }
  });
}

export function hasQt(): boolean {
  return typeof qt === 'object';
}
